import { Box, Flex, VStack } from '@revolut-internal/ui-kit'
import { useLayoutEffect } from 'react'

import { useScrollToBottom } from 'pages/shared/hooks/useScrollToBottom'
import { ErrorWidget, NotFoundWidget } from 'components'
import { NotFoundError } from 'lib/apiClient'

import { MessageGroupType } from '../../types'
import { usePrompt } from '../../providers/PromptProvider'
import { DateMessage } from './DateMessage'
import { StackMessage } from './StackMessage'

export const DialogueSnapshot = () => {
  const { messageGroups, dialogSnapshotError, isLoading } = usePrompt()
  const { scrollToBottom, containerRef } = useScrollToBottom()

  useLayoutEffect(() => {
    scrollToBottom()
  }, [messageGroups, scrollToBottom])

  if (isLoading) {
    return null
  }

  if (dialogSnapshotError) {
    return (
      <Flex mt="20%" alignItems="center" justifyContent="center">
        <Box maxWidth="620px">
          {dialogSnapshotError instanceof NotFoundError ? (
            <NotFoundWidget
              title="Dialog snapshot not found"
              description={
                typeof dialogSnapshotError?.cause === 'string'
                  ? dialogSnapshotError.cause
                  : undefined
              }
            />
          ) : (
            <ErrorWidget />
          )}
        </Box>
      </Flex>
    )
  }

  if (!messageGroups || !messageGroups.length) {
    return null
  }

  return (
    <Box ref={containerRef} width="100%" height="100%" overflow="auto" p="s-24">
      <VStack space="s-16">
        {messageGroups.map(group => {
          switch (group.type) {
            case MessageGroupType.Date:
              return <DateMessage key={group.timestamp} timestamp={group.timestamp} />

            case MessageGroupType.Stack:
              return (
                <StackMessage
                  key={group.messages[group.messages.length - 1].messageId}
                  {...group}
                />
              )

            default:
              throw new Error('Unknown message group type')
          }
        })}
      </VStack>
    </Box>
  )
}
